import partnerAdminRequests from './partnerAdmin'

export default {
  partnerAdminRequests,
}
